import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import { isPlatformFeatureEnabled } from "../config/platformFeatures";
import type { AppsPreset, PlatformFeature } from "../config/apps/types";

/** A dónde va quien escribe la URL de una función apagada en esta plataforma. */
export const DISABLED_FEATURE_REDIRECT = "/apps";

/**
 * La ruta tal cual si su familia está encendida; si está apagada, la misma ruta
 * (y todo lo que cuelga de ella) redirige al inicio sin montar la pantalla.
 */
export function gateRouteByFeature(
  route: RouteObject,
  feature: PlatformFeature,
  preset?: Pick<AppsPreset, "disabledFeatures">,
): RouteObject {
  if (isPlatformFeatureEnabled(feature, preset)) return route;
  const redirect = <Navigate to={DISABLED_FEATURE_REDIRECT} replace />;
  return {
    path: route.path,
    element: redirect,
    children: [{ path: "*", element: redirect }],
  };
}

/**
 * Para una ruta que sigue encendida pero tiene sub-rutas de una familia apagada
 * (p. ej. `/gestion-staff`: Actividades sí, Horas y Equipo no): con la familia
 * apagada, `<ruta>/<slug>` y todo lo que cuelga de él redirigen al inicio; con
 * la familia encendida, la ruta queda tal cual.
 */
export function gateChildPathsByFeature(
  route: RouteObject,
  slugs: string[],
  feature: PlatformFeature,
  preset?: Pick<AppsPreset, "disabledFeatures">,
): RouteObject {
  if (isPlatformFeatureEnabled(feature, preset)) return route;
  const redirect = <Navigate to={DISABLED_FEATURE_REDIRECT} replace />;
  const gated: RouteObject[] = slugs.map((slug) => ({ path: slug, element: redirect, children: [{ path: "*", element: redirect }] }));
  return { ...route, children: [...gated, ...(route.children ?? [])] } as RouteObject;
}
